
  import { defineComponent, PropType } from 'vue';

  export default defineComponent({
    name: 'RangeFieldLayout',
    props: {
      // Подписи «От»/«До» слева от полей. Если не заданы — используются плейсхолдеры внутри полей.
      labels: {
        type: Array as PropType<string[]>,
        default: undefined,
      },
    },
    computed: {
      hasLabels(): boolean {
        return Array.isArray(this.labels) && this.labels.length === 2;
      },
    },
  });
